<!-- Outer gutter matches the storefront wrapper; the inner box carries the merchant's own
     background / padding / border. -->
<div class="goals-preview-outer" [ngStyle]="outerStyle">
  <div class="goals-preview" [ngStyle]="boxStyle">
    @if (completedPills.length) {
      <div class="pills-row">
        @for (pill of completedPills; track $index) {
          <span class="pill" [ngStyle]="pillStyle">{{ pill }}</span>
        }
      </div>
    }

    @if (messageHtml || showTimerBadge || (barType === 'sequential' && activeCheckpoint?.iconUrl)) {
      <div class="goal-message-row">
        @if (barType === 'sequential' && activeCheckpoint?.iconUrl) {
          <img class="seq-icon" [src]="activeCheckpoint?.iconUrl" alt="" />
        }
        @if (messageHtml) {
          <div class="goal-message" [style.padding]="messagePadding" [innerHTML]="messageHtml"></div>
        }
        @if (showTimerBadge) {
          <span class="timer-badge" [ngStyle]="timerStyle">
            @if (timerIconUrl) {
              <img class="timer-icon-badge" [src]="timerIconUrl" alt="" />
            }
            <span [innerHTML]="timerMessageHtml"></span>
          </span>
        }
      </div>
    }

    @switch (barType) {
      @case ('single_bar') {
        <div class="single-bar" [style.grid-template-columns]="barGridColumns">
          <!-- Sizes the reserve columns and nothing else: hidden, zero height, so it only contributes
               its intrinsic width. Same font size as the label it stands in for. -->
          @for (text of endLabelTexts; track $index) {
            <span class="end-label-sizer" [style.font-size.px]="endLabelSize" aria-hidden="true">{{ text }}</span>
          }
          @if (singleHasAboveLabels) {
            <div
              class="label-layer label-layer--above"
              [style.height.px]="labelLayerHeight"
              [style.margin-bottom.px]="checkpointLabelOffset">
              @for (cp of checkpoints; track cp.originalIndex) {
                @if (cp.aboveText) {
                  <span class="abs-label" [style.left.%]="cp.position" [style.font-size.px]="cp.labelSize">{{
                    cp.aboveText
                  }}</span>
                }
              }
            </div>
          }

          <!-- Where a label row is absent, nothing holds the circle clear, so reserve its overhang. -->
          <div
            class="track-row"
            [style.height.px]="barHeight"
            [style.margin-top.px]="singleHasAboveLabels ? 0 : checkpointOverhang"
            [style.margin-bottom.px]="singleHasBelowLabels ? 0 : checkpointOverhang">
            <div class="track" [style.height.px]="barHeight" [style.border-radius.px]="barRadius"></div>
            <div
              class="fill"
              [style.width.%]="singleFillPercent"
              [style.height.px]="barHeight"
              [style.border-radius.px]="barRadius"
              [style.background-color]="fillColor"></div>
            @for (cp of checkpoints; track cp.originalIndex) {
              <div
                class="checkpoint"
                [style.left.%]="cp.position"
                [style.background-color]="cp.completed ? fillColor : '#ffffff'"
                [style.border-color]="cp.completed ? fillColor : trackColor">
                @if (cp.completed) {
                  <span class="checkpoint-check">✓</span>
                } @else if (cp.iconUrl) {
                  <img class="checkpoint-icon" [src]="cp.iconUrl" alt="" />
                } @else {
                  <span class="checkpoint-dot"></span>
                }
              </div>
            }
          </div>

          @if (singleHasBelowLabels) {
            <div
              class="label-layer label-layer--below"
              [style.height.px]="labelLayerHeight"
              [style.margin-top.px]="checkpointLabelOffset">
              @for (cp of checkpoints; track cp.originalIndex) {
                @if (cp.belowText) {
                  <span class="abs-label" [style.left.%]="cp.position" [style.font-size.px]="cp.labelSize">{{
                    cp.belowText
                  }}</span>
                }
              }
            </div>
          }
        </div>
      }

      @case ('inline') {
        <div class="inline-bars">
          @for (cp of checkpoints; track cp.originalIndex) {
            <div class="inline-col">
              @if (inlineHasAbove) {
                <div class="inline-label" [style.font-size.px]="cp.labelSize">
                  @if (cp.iconUrl && cp.iconAbove) {
                    <img class="inline-icon" [src]="cp.iconUrl" alt="" />
                  }
                  @if (cp.aboveText) {
                    <span>{{ cp.aboveText }}</span>
                  }
                </div>
              }
              <div class="inline-track" [style.height.px]="barHeight" [style.border-radius.px]="barRadius">
                <div
                  class="inline-fill"
                  [style.width.%]="cp.inlineFill"
                  [style.border-radius.px]="barRadius"
                  [style.background-color]="fillColor"></div>
              </div>
              @if (inlineHasBelow) {
                <div class="inline-info" [style.font-size.px]="cp.labelSize">
                  @if (cp.iconUrl && !cp.iconAbove) {
                    <img class="inline-icon" [src]="cp.iconUrl" alt="" />
                  }
                  @if (cp.belowText) {
                    <span>{{ cp.belowText }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @default {
        <div class="sequential">
          <div class="seq-track" [style.height.px]="barHeight" [style.border-radius.px]="barRadius">
            <div
              class="seq-fill"
              [style.width.%]="sequentialFillPercent"
              [style.border-radius.px]="barRadius"
              [style.background-color]="fillColor"></div>
          </div>
        </div>
      }
    }

    @if (showTimerStrip) {
      <div class="timer-strip" [ngStyle]="timerStyle" [style.justify-content]="timerAlign">
        @if (timerIconUrl) {
          <img class="timer-icon-strip" [src]="timerIconUrl" alt="" />
        }
        <span [innerHTML]="timerMessageHtml"></span>
      </div>
    }

    @if (showApplySection) {
      <div class="apply-section" [ngStyle]="applyBoxStyle">
        <div class="apply-texts" [ngStyle]="applyTextStyle">
          <div class="apply-title">{{ applySection?.texts?.title }}</div>
          @if (applySection?.texts?.subtitle) {
            <div class="apply-subtitle" [innerHTML]="applySection?.texts?.subtitle"></div>
          }
        </div>
        @if (!isMultipleGifts) {
          <div class="apply-product">
            <ng-container *ngTemplateOutlet="productCard; context: { $implicit: applyProductsView[0] }"></ng-container>
          </div>
        } @else if (productDisplayType === 'compact') {
          <!-- carousel: first product with the nav arrows grouped together (preview only) -->
          <div class="apply-compact">
            <div class="apply-product">
              <ng-container
                *ngTemplateOutlet="productCard; context: { $implicit: applyProductsView[0] }"></ng-container>
            </div>
            <div class="apply-compact-nav">
              <span class="carousel-arrow" aria-hidden="true">‹</span>
              <span class="carousel-arrow" aria-hidden="true">›</span>
            </div>
          </div>
        } @else {
          <!-- list: radio per product (preview only, first pre-selected) -->
          <div class="apply-list">
            @for (product of applyProductsView; track $index) {
              <div class="apply-list-item">
                <span class="apply-radio" [class.checked]="$first"></span>
                <div class="apply-product">
                  <ng-container *ngTemplateOutlet="productCard; context: { $implicit: product }"></ng-container>
                </div>
              </div>
            }
          </div>
        }
        <button class="apply-button" type="button" [ngStyle]="applyButtonStyle">
          {{ applySection?.button?.label }}
        </button>
      </div>

      <ng-template #productCard let-product>
        @if (product?.imageUrl) {
          <div class="apply-image" [ngStyle]="applyImageStyle">
            <img [src]="product.imageUrl" [style.object-fit]="applyImageObjectFit" alt="" />
          </div>
        }
        <div class="apply-product-info" [ngStyle]="applyTextStyle">
          <span class="apply-product-name">{{ product?.name }}</span>
          @if (product?.price) {
            <span class="apply-product-price">{{ product.price }}</span>
          }
        </div>
      </ng-template>
    }
  </div>
</div>
